import Vue from 'vue'
import Router from 'vue-router'
import storage from '@/model/utils/localStorage'
import $store from '@/model/store/index'
import {
    initToken
} from '@/model/api/login'

Vue.use(Router)

const router = new Router({
    linkActiveClass: 'actived',
    // mode:'history',
    routes: [{
            path: '/',
            name: '官网首页',
            component: () => import('@/view/pages/Home.vue')
        },
        {
            path: '/index',
            name: '主容器',
            component: () => import('@/view/pages/Index.vue'),
            // redirect: 'dashboard',
            children: [{
                    path: '/',
                    name: '数据概览',
                    component: () => import('@/view/pages/dashboard/Dashboard.vue')
                },
                {
                    path: '/usermanage',
                    name: '用户管理',
                    component: () => import('@/view/pages/usermanage/UserManage.vue')
                },
                {
                    path: '/userdetails',
                    name: '用户详情',
                    component: () => import('@/view/pages/usermanage/UserDetails.vue')
                },
                {
                    path: '/devicemanage',
                    name: '设备管理',
                    component: () => import('@/view/pages/devicemanage/DeviceManage.vue')
                },
                {
                    path: '/account',
                    name: '账户管理',
                    component: () => import('@/view/pages/account/Account.vue')
                },
                {
                    path: '/abnormal',
                    name: '异常预警',
                    component: () => import('@/view/pages/abnormalwarning/AbnormalWarning.vue')
                }
            ]
        },
        {
            path: '/login',
            name: '登录',
            component: () => import('@/view/pages/login/Login.vue')
        },
        {
            path: '/editpwd',
            name: '修改密码',
            component: () => import('@/view/pages/login/EditPwd.vue')
        },
        {
            path: '/editinitpwd',
            name: '修改初始密码',
            component: () => import('@/view/pages/login/EditInitPwd.vue')
        },
        {
            path: '/editsuccess',
            name: '修改密码成功',
            component: () => import('@/view/pages/login/EditSuccess.vue')
        },
        {
            path: '/preView',
            name: '大屏预览',
            component: resolve => require(['@/view/pages/bigScreem/bigPreView.vue'], resolve)
          }
    ]
 
})

const isLogin = storage.token ? true : false

router.beforeEach((to, from, next) => {
    if(to.path === '/') {
        var divShow = document.getElementById('newBridge');
        console.log(divShow)
    }
    if (isLogin) {
        if (to.path === '/login') {
            return next('/index')
        } else {
            initToken(storage.token, storage.username, storage.account)
            $store.commit('added', to)
            next()
        }
    } else {
        storage.clearKeysByUser()
        if (to.path !== '/login') {
            // 回首页->不要到loin
            if(to.path.length>1){
                next('/login')   
            }
            else{
                next()
            }
        } 
        else {
            next()           
        }       
    }
})

export default router